<div class="example-container" [class.example-is-mobile]="mobileQuery.matches">


    <mat-sidenav-container class="example-sidenav-container"
                          [style.marginTop.px]="mobileQuery.matches ? 56 : 0">
      <mat-sidenav #snav [mode]="mobileQuery.matches ? 'over' : 'side'"
                  [fixedInViewport]="mobileQuery.matches" fixedTopGap="56" opened>
        <mat-nav-list>
          @for (nav of fillerNav; track nav) {
            <a mat-list-item routerLink=".">{{nav}}</a>
          }
        </mat-nav-list>
      </mat-sidenav>

      <mat-sidenav-content>

        <button mat-icon-button (click)="snav.toggle()"><mat-icon>menu</mat-icon></button>
        <app-cruscotto-richiesta></app-cruscotto-richiesta>
      </mat-sidenav-content>
    </mat-sidenav-container>
  </div>